"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageManager = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const languageUtils_1 = require("./languageUtils");
const langHTML = {
    en: 'en-US',
    ca: 'en-CA',
    uk: 'en-GB',
    au: 'en-AU',
    nz: 'en-NZ',
    fr: 'fr-FR',
    de: 'de-DE',
    es: 'es-ES',
    it: 'it-IT',
    pt: 'pt-PT',
    nl: 'nl-NL',
};
exports.LanguageManager = {
    getQueryParameter(name) {
        return new URLSearchParams(window.location.search).get(name);
    },
    setHTMLLang() {
        const pageHTML = document.documentElement;
        const language = (0, languageUtils_1.getLanguage)();
        if (langHTML[language]) {
            pageHTML.lang = langHTML[language];
        }
    },
    initializeLanguage() {
        const langQuery = this.getQueryParameter('lang');
        const langCookie = js_cookie_1.default.get('lang');
        const isValidLangQuery = langQuery && langHTML.hasOwnProperty(langQuery);
        if (isValidLangQuery && langCookie && langQuery !== langCookie) {
            (0, languageUtils_1.setLanguage)(langQuery);
        }
        else if (isValidLangQuery && !langCookie) {
            (0, languageUtils_1.setLanguage)(langQuery);
        }
        else if (!langQuery && !langCookie) {
            const hostname = window.location.hostname;
            const isNA = hostname.startsWith('na');
            const isEU = hostname.startsWith('eu');
            let defaultLang = 'en'; // Safe fallback
            if (isNA) {
                defaultLang = 'en';
            }
            else if (isEU) {
                defaultLang = 'uk'; // Change to your default EU language
            }
            else {
                console.log('[LanguageManager] Unknown domain — using default "en"');
            }
            (0, languageUtils_1.setLanguage)(defaultLang);
        }
        const currentLang = (0, languageUtils_1.getLanguage)();
        const urlParams = new URLSearchParams(window.location.search);
        if (currentLang === 'en') {
            urlParams.delete('lang');
        }
        else {
            urlParams.set('lang', currentLang);
        }
        const hash = window.location.hash;
        console.log(hash);
        const newUrl = urlParams.toString()
            ? `?${urlParams.toString()}${hash}`
            : `${window.location.pathname}${hash}`;
        history.replaceState(null, '', newUrl);
        this.setHTMLLang();
    },
    // initializeLanguage(): void {
    //   const langQuery = this.getQueryParameter('lang');
    //   const langCookie = Cookies.get('lang');
    //   // Validate if the language from the query is a supported language
    //   const isValidLangQuery = langQuery && langHTML.hasOwnProperty(langQuery);
    //   if (isValidLangQuery && langCookie && langQuery !== langCookie) {
    //     setLanguage(langQuery as LanguageKey);
    //   } else if (isValidLangQuery && !langCookie) {
    //     setLanguage(langQuery as LanguageKey);
    //   } else if (!langQuery && !langCookie) {
    //     setLanguage('en');
    //   }
    //   const currentLang = getLanguage();
    //   // 🌐 DOMAIN SWITCHING LOGIC
    //   const currentDomain = window.location.hostname;
    //   const naLanguages = ['en', 'ca', 'us'];
    //   const shouldBeNa = naLanguages.includes(currentLang);
    //   const expectedDomain = shouldBeNa ? 'na.dxm.com' : 'eu.dxm.com';
    //   if (currentDomain !== expectedDomain) {
    //     const path = window.location.pathname;
    //     const query = currentLang === 'en' ? '' : `?lang=${currentLang}`;
    //     const newUrl = `https://${expectedDomain}${path}${query}`;
    //     window.location.replace(newUrl);
    //     return; // Stop execution here since we're redirecting
    //   }
    //   // ✅ Update lang attribute on <html>
    //   this.setHTMLLang();
    //   // ✅ Update URL params (remove ?lang=en, or set ?lang=xx)
    //   const urlParams = new URLSearchParams(window.location.search);
    //   if (currentLang === 'en') {
    //     urlParams.delete('lang');
    //   } else {
    //     urlParams.set('lang', currentLang);
    //   }
    //   const newUrl = urlParams.toString()
    //     ? `${window.location.pathname}?${urlParams.toString()}`
    //     : window.location.pathname;
    //   history.replaceState(null, '', newUrl);
    // }
};
